import React from 'react';
import { useSubscription } from '@apollo/react-hooks';
import classnames from 'classnames';
import styles from './SubscriptionPlaygroundScreen.module.scss';
import gql from 'graphql-tag';
import { Redirect } from 'react-router-dom';
import { appStage } from 'helpers/constants';

export const NODE_PINNED_SUBSCRIPTION = gql`
  subscription nodeUpdatedSubscription($nodeId: String!) {
    nodeUpdated(nodeId: $nodeId) {
      eventType
      node {
        id
        title
        pins
      }
    }
  }
`;

export const GROUP_SUBSCRIPTION = gql`
  subscription groupUpdatedSubscription($groupId: String!) {
    groupUpdated(groupId: $groupId) {
      eventType
      group {
        id
        title
      }
    }
  }
`;

export const DisplayNewPins = () => {
  const { data, loading, error } = useSubscription(NODE_PINNED_SUBSCRIPTION, {variables: {nodeId: "n-google_drive@1.0.0-1Lzj4OUG9vwUqHvMgiYeYkRw6NXdvNqvrRIh9L3_SIwI"}});

  if (data) {
    console.log('ddd', data);
  }

  if (error) {
    console.log('err', error);
  }

  return (
    <div>
      <div>
        <div style={{ fontSize: 16, fontWeight: 500 }}>Node:</div>
      </div>
      {!loading && (
        <>
          <div style={{ width: '100%', border: '1px solid #333' }}>
            <p>Event: {data?.nodeUpdated?.eventType}</p>
            <p>Node id: {data?.nodeUpdated?.node.id}</p>
          </div>
        </>
      )}
    </div>
  );
};

export const DisplayGroup = () => {
  const { data, loading, error } = useSubscription(GROUP_SUBSCRIPTION, {variables: {groupId: "g-2c6fd836-8fd4-4999-9b37-91429fcc4227"}});

  if (data) {
    console.log('ddd', data);
  }

  if (error) {
    console.log('err', error);
  }

  return (
      <div>
        <div>
          <div style={{ fontSize: 16, fontWeight: 500 }}>Group:</div>
        </div>
        {!loading && (
            <>
              <div style={{ width: '100%', border: '1px solid #333' }}>
                <p>Event: {data?.groupUpdated?.eventType}</p>
                <p>Group: {data?.groupUpdated?.group.id} - {data?.groupUpdated?.group.name}</p>
              </div>
            </>
        )}
      </div>
  );
};

export const SubscriptionPlaygroundScreen = () => {
  if (appStage === 'prod' || appStage === 'staging') {
    return <Redirect to={'/'} />;
  }

  return (
    <>
      <div className={styles.content}>
        <div className={classnames(styles.contentBin, styles.layoutTetris)}>
          <div className={styles.ProfileContainer}>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
              <DisplayNewPins />
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
              <DisplayGroup />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
